import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { ERROR_BOUNDARY_ID_JWM_LIST_TOUR_NUDGE } from '../../../common/constants';
import type { WrapperProps } from '../../../common/types';
import { inlineEditNudgeEntrypoint } from './entrypoint';

const runtimeProps = {};
const entryPointParams = {};
export const InlineEditListNudgeAsync = (props: WrapperProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		inlineEditNudgeEntrypoint,
		entryPointParams,
	);

	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<>
			{props.children}
			<JiraEntryPointContainer
				id={ERROR_BOUNDARY_ID_JWM_LIST_TOUR_NUDGE}
				packageName="jiraListOnboarding"
				entryPointReferenceSubject={entryPointReferenceSubject}
				fallback={<></>}
				runtimeProps={runtimeProps}
			/>
		</>
	);
};
